import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/* eslint-disable @atlaskit/platform/no-invalid-feature-flag-usage */
import { fg } from '@atlaskit/platform-feature-flags';
var TIME_IN_MS = 1000;
var MAX_WAIT_TIME = 300 * TIME_IN_MS;
var INITIAL_WAIT_TIME = 2 * TIME_IN_MS;
export var pollForBrowserControlsFlag = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var waitTime,
      totalElapsedTime,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          waitTime = _args.length > 0 && _args[0] !== undefined ? _args[0] : INITIAL_WAIT_TIME;
          totalElapsedTime = _args.length > 1 && _args[1] !== undefined ? _args[1] : 0;
          return _context.abrupt("return", pollForFeatureFlag('platform.moonjelly.browser-storage-controls', waitTime, totalElapsedTime));
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function pollForBrowserControlsFlag() {
    return _ref.apply(this, arguments);
  };
}();
var pollForFeatureFlag = function pollForFeatureFlag(featureFlag) {
  var waitTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INITIAL_WAIT_TIME;
  var totalElapsedTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  /*
     We don't know exactly if/when the FF will be enabled, so we want to exponentially poll from 2s to a max of ~5min
     If it never comes back as 'true' then we assume that:
       a) it's correctly set to false and thus we don't override the document.cookie behavior
       b) the FF client failed to load in time, don't override the behavior by making false assumptions
   */
  var shouldCancelPolling = totalElapsedTime > MAX_WAIT_TIME;
  if (shouldCancelPolling) {
    return Promise.resolve(false);
  }

  // eslint-disable-next-line @atlaskit/platform/static-feature-flags
  if (!fg(featureFlag)) {
    var newWaitTime = waitTime * 2;

    // Use the max if new wait time exceeds it
    var cappedWaitTime = Math.min(newWaitTime, MAX_WAIT_TIME);
    return new Promise(function (resolve) {
      setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var updatedElapsedTime, newFlagState;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              updatedElapsedTime = totalElapsedTime + cappedWaitTime;
              _context2.next = 3;
              return pollForBrowserControlsFlag(cappedWaitTime, updatedElapsedTime);
            case 3:
              newFlagState = _context2.sent;
              resolve(newFlagState);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })), cappedWaitTime);
    });
  }
  return Promise.resolve(true);
};